/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `ButtonType*`'s.
 */
export type ButtonType = ButtonTypeButton | ButtonTypeReset | ButtonTypeSubmit;

/**
 * The basic button type.
 */
export type ButtonTypeButton = typeof BUTTON_TYPE_BUTTON;

/**
 * The reset button type.
 */
export type ButtonTypeReset = typeof BUTTON_TYPE_RESET;

/**
 * The submit button type.
 */
export type ButtonTypeSubmit = typeof BUTTON_TYPE_SUBMIT;

/**
 * The basic button constant.
 */
export const BUTTON_TYPE_BUTTON = `button`;

/**
 * The reset button constant.
 */
export const BUTTON_TYPE_RESET = `reset`;

/**
 * The submit button constant.
 */
export const BUTTON_TYPE_SUBMIT = `submit`;
